<template>
  <div class="con8">
    <div class="container">
      <p class="text-title">완벽한 영어 말하기의<br />쾌감을 느끼다!</p>
      <div class="m-slide">
        <VueSlickCarousel ref="carousel" v-bind="settings">
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img0.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img1.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img2.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img3.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img4.png" alt="" />
          </div>
          <div class="item">
            <img src="@/assets/img/aitutorplus/con8/img5.png" alt="" />
          </div>
        </VueSlickCarousel>
      </div>
      <ul class="pc-content">
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon0.png" alt="" />
          <p>정OO님</p>
          <p>말랑톡으로<br />영어 울렁증 극복!</p>
          <p>
            사람과 대화하는 스트레스가 없었고,<br />부끄럽지 않아서 좋았어요.<br />영어
            울렁증이 있어서 전화영어도<br />효과가 없었는데 매우
            만족스러웠습니다.
          </p>
        </li>
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon1.png" alt="" />
          <p>김OO님</p>
          <p>언제 어디서든<br />말하기 연습!</p>
          <p>
            시간과 장소에 구애받지 않고 혼자서도<br />말하기 연습을 할 수 있어서
            편리했어요.<br />콘텐츠가 다양해서<br />고르는 재미가 있었습니다!
          </p>
        </li>
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon2.png" alt="" />
          <p>김OO님</p>
          <p>어려운 영어 발음도<br />자신있게!</p>
          <p>
            제 발음을 다시 들을 수 있어서 좋았습니다.<br />발음을 직접 확인하고
            다시 듣는 과정이<br />정말 많이 도움이 되었고, 덕분에 영어로<br />말하는
            데에 자신감이 붙었습니다.
          </p>
        </li>
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon3.png" alt="" />
          <p>박OO님</p>
          <p>상황에 맞는 가이드로<br />실력 업!</p>
          <p>
            말랑톡을 하면서 구문을 익히고<br />상황에 맞게 가이드를 주어<br />실생활
            영어에 도움이 많이 되었어요.
          </p>
        </li>
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon4.png" alt="" />
          <p>최OO님</p>
          <p>유학 고민<br />말랑톡과 해결!</p>
          <p>
            저 포함 주변 친구들도<br />어학연수나 유학을 포기하고<br />영어공부에
            대한 고민이 많았는데<br />말랑톡으로 고민이 줄어들었어요!
          </p>
        </li>
        <li>
          <img src="@/assets/img/aitutorplus/con8/icon5.png" alt="" />
          <p>공OO님</p>
          <p>재미있게<br />회화 레벨업!</p>
          <p>
            저는 회화가 1순위 목적인데 대화에 대한<br />핑퐁이 가능한 점이 매우
            마음에 들었어요.<br />대답을 할 수 있도록 힌트를 제시해 주셔서<br />문장
            만드는 게 수월했던 것 같습니다.
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      settings: {
        initialSlide: 0,
        centerMode: true,
        swipeToSlide: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        cssEase: "ease-out",
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        dots: false,
      },
    };
  },
};
</script>
<style lang="scss" scoped>
img {
  display: block;
  width: 100%;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;

  @media screen and (min-width: 1200px) {
    padding: 0;
  }
}

.br-m {
  @media screen and (min-width: 1200px) {
    display: none;
  }
}

.con8 {
  padding: 86px 0;
  background-color: #f3f4f6;

  @media screen and (min-width: 1200px) {
    padding: 174px 0;
  }

  .text-title {
    font-size: 30px;
    font-weight: 700;
    color: #18181b;
    text-align: center;
    margin-bottom: 46px;

    span {
      font-size: 15px;
      font-weight: 400;
    }

    @media screen and (min-width: 1200px) {
      font-size: 52px;
      margin-bottom: 82px;

      span {
        font-size: 30px;
      }
    }
  }

  .m-slide {
    @media screen and (min-width: 1200px) {
      display: none;
    }

    :deep(.slick-slider) {
      .slick-list {
        .slick-track {
          .slick-slide {
            padding: 0 10px;

            > div {
              .item {
                img {
                  max-width: 295px;
                  margin: 0 auto;
                }
              }
            }
          }
        }
      }
    }
  }

  .pc-content {
    display: none;

    @media screen and (min-width: 1200px) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 26px;
    }

    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 46px;
      border-radius: 26px;

      &:nth-child(odd) {
        background-color: #fff;
      }

      &:nth-child(even) {
        border: 1px solid #8b95a1;
      }

      img {
        width: 82px;
        margin-bottom: 8px;
      }

      p {
        &:nth-of-type(1) {
          font-size: 17px;
          font-weight: 500;
          color: #6b7280;
          margin-bottom: 18px;
        }

        &:nth-of-type(2) {
          font-size: 30px;
          font-weight: 700;
          color: #18181b;
          text-align: center;
          margin-bottom: 16px;
        }

        &:nth-of-type(3) {
          font-size: 18px;
          color: #18181b;
          text-align: center;
          line-height: 26px;
        }
      }
    }
  }
}
</style>
